export default "assets/frame-4.c85b22656e047a76.png"